import {Box, Button, IconButton, Typography} from '@mui/material';
import { useEffect, useState } from 'react';
import { Hall } from '../../common/interfaces/hall';
import {deleteHall, fetchAllHalls} from '../../api/hall';
import { createToastNotification } from '../../utilities/helpers';
import { HallModal } from './HallModal/HallModal';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import {DataGrid, GridColDef} from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ConfirmationModal from '../../components/ConfirmationModal';

const Halls = () => {

  const [hallModalOpened, setHallModalOpened] = useState(false);
  const [selectedHall, setSelectedHall] = useState<Hall | null>(null);
  const [hallsData, setHallsData] = useState<Hall[]>([]);
  const [totalHalls, setTotalHalls] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(5);
  const paginationModel = {page: page, pageSize: perPage};

  const [confirmDeleteDialogIsOpened, setConfirmDeleteDialogIsOpened] = useState(false);
  const hallColumns: GridColDef[] = [
    {field: 'id', headerName: 'ID', width: 70, sortable: false},
    {field: 'name', headerName: 'Naziv', flex:2, sortable: false},
    {field: 'description', headerName: 'Opis', type: 'string', flex:3, sortable: false},
      {
          field: 'action',
          headerName: '',
          flex:1,
          renderCell: (params) => (
              <Tooltip title="Ukloni halu" arrow>
                  <IconButton
                      onClick={(event) => {
                          event.stopPropagation()
                          const hall: Hall = {
                              id: params.row.id ?? undefined,
                              //@ts-ignore
                              name: params.row.name ?? '',
                              //@ts-ignore
                              description: params.row.description ?? ''
                          }
                          setSelectedHall(hall);
                          setConfirmDeleteDialogIsOpened(true)
                      }}
                  >
                      <DeleteOutlineIcon color="error" />
                  </IconButton>
              </Tooltip>
          ),
      },
  ];

  const fetchHalls = async () => {
    try {
        const data = {
            page:page,
            perPage:perPage
        }
      const response = await fetchAllHalls(data);
        setHallsData(response.halls);
        setTotalHalls(response.totalItems)
    } catch (error: any) {
      createToastNotification('error', error.response?.data?.message);
    }
  };

  const handleHallRowClick = async (params: { row: { id: any } }) => {
    const hall: Hall = {
      id: params.row.id ?? undefined,
      //@ts-ignore
      name: params.row.name ?? '',
      //@ts-ignore
      description: params.row.description ?? ''
    }
    setSelectedHall(hall);
    setHallModalOpened(true);
  }

  useEffect(() => {
    fetchHalls();
  }, [page,perPage]);

  // @ts-ignore
  return (
    <Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h4">Lista hala</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setHallModalOpened(true);
            setSelectedHall(null);
          }}
          startIcon={<AddIcon />}
        >
          Kreiraj novu halu
        </Button>
      </Box>
      <br />
      <DataGrid
          disableColumnMenu
          disableRowSelectionOnClick
          disableMultipleRowSelection
          rows={hallsData}
          rowCount={totalHalls}
          columns={hallColumns}
          onRowClick={handleHallRowClick}
          pagination
          paginationModel={{
            page: paginationModel.page - 1,
            pageSize: paginationModel.pageSize
          }}
          paginationMode={'server'}
          pageSizeOptions={[5, 10]}
          //@ts-ignore
          onPaginationModelChange={(model) => {
            setPage(model.page + 1)
            setPerPage(model.pageSize)
          }}
          sx={{
              marginTop:2,
              paddingLeft:'10px',
              paddingRight:'10px',
              border: 0,
              '.MuiDataGrid-cell:focus': {
                  outline: 'none',
              }
          }}
          localeText={{
            MuiTablePagination: {
              labelRowsPerPage: "Redova po strani",
              labelDisplayedRows: ({from, to, count}) =>
                  `${from} - ${to} od ${count !== -1 ? count : ` ${to}`}`,
            },
            noRowsLabel: "Nema dostupnih podataka",
          }}
      />

      <HallModal
          modalName={
            selectedHall?.id !== undefined ? 'Izmeni halu' : 'Dodaj novu halu'
        }
        hall={selectedHall}
        opened={hallModalOpened}
        handleClose={async (refresh?: boolean) => {
          if (refresh) {
            await fetchHalls();
          }
          setHallModalOpened(false);
        }}
      />
        {confirmDeleteDialogIsOpened && (
            <ConfirmationModal
                confirmationModalTitle="Brisanje hale"
                cancelAction={() => {
                    setSelectedHall(null)
                    setConfirmDeleteDialogIsOpened(false)
                }}
                handleAction={async () => {

                    if (!(selectedHall?.id)) {
                        createToastNotification("error", 'Hala nije obrisana uspešno');
                        setSelectedHall(null)
                        setConfirmDeleteDialogIsOpened(false)
                        return;
                    }

                    try {
                        await deleteHall(Number(selectedHall?.id))
                        createToastNotification('success', 'Hala je uspešno obrisana')
                    } catch (error: any) {
                        createToastNotification("error", error?.response?.data?.message);
                    } finally {
                        fetchHalls()
                        setSelectedHall(null)
                    }

                    setConfirmDeleteDialogIsOpened(false)
                }
                }
                confirmBtnTitle="Potvrdi brisanje"
                modalDescription="Da li ste sigurni da želite da obrišete halu?"
                cancelBtnTitle="Odustani"
            />
        )}
    </Box>
  );
};
export default Halls;
